import React, { memo } from 'react';
import PropTypes from 'prop-types';
import Snackbar from '@techsoftware/happay-widgets/Snackbar';

function CustomSnackbar(props) {
  const { open, position, message, type, showIcon, time } = props;

  return (
    <Snackbar
      message={message}
      showSnackbar={open}
      position={position}
      // title={title}
      type={type}
      showIcon={showIcon}
      snackBarTime={time}
      onClose={() => props.closeSnackBar()}
    />
  );
}

export default memo(CustomSnackbar);

CustomSnackbar.propTypes = {
  open: PropTypes.bool,
  position: PropTypes.string,
  message: PropTypes.string,
  type: PropTypes.string,
  showIcon: PropTypes.bool,
  time: PropTypes.number
};

CustomSnackbar.defaultProps = {
  open: false,
  position: 'center-bottom',
  message: 'Something Went Wrong!',
  type: 'success',
  showIcon: true,
  time: 10000
};
